import React from "react"
import Image from "next/image"
import Link from "next/link"
import { useLanguageQuery } from "next-export-i18n"

const Footer = () => {
  const [query] = useLanguageQuery()
  return (
    <div className="w-full  bg-lightBlue py-4">
      <div className="max-w-7xl mx-auto px-4 ">
        <div className="flex justify-between flex-wrap gap-4 ">
          <div className="w-full md:w-auto">
            <div className="flex">
              <Link className="group " href={{ pathname: "/", query: query }}>
                <a className="transform hover:scale-125 transition-all duration-300">
                  <Image
                    src="/images/ERVCClogo.png"
                    width={240}
                    height={60}
                    alt="ERVCC logo"
                  />
                </a>
              </Link>
              <div className="group -mt-2  pl-5">
                <a href="https://norwestchc.org/">
                  <Image
                    src="/images/care.png"
                    width={250}
                    height={76}
                    alt="NorWest Commnunity Health Centres logo"
                  />
                </a>
              </div>
            </div>
            <div className="flex "></div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-center md:self-center text-center  max-w-7xl  mx-auto ptr  text-sm md:text-base pt-2 border-t  border-secondary text-secondary">
          <p className="mr-4 md:self-center">
            Copyright {new Date().getFullYear()}. All rights reserved.
          </p>
          <Link href="/privacy-policy/" legacyBehavior>
            <a className=" mr-4 md:self-center hover:text-primary">
              Privacy Policy
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Footer
